import { Receipt } from "../receipt";
import { Voucher } from "../voucher";
import { ContractReturnResponseModel } from "./contract-return-response-model";

export class ContractReturnResponseCompleteModel {
    contractReturnResponseModel: ContractReturnResponseModel;
    voucher: Voucher;
    receipt: Receipt;
    constructor() {
        this.contractReturnResponseModel = new ContractReturnResponseModel();
        this.voucher = new Voucher();
        this.receipt = new Receipt();
    }
}